import Carousel from "@/components/slider/Carousel";
import Link from "next/link";
import Image from "next/legacy/image";
import { fitIn } from "@/utils/imageHandler";

/**
 * `onSelect` opts a caller into showing the guest's episodes inline: the card
 * stays a real link (so crawlers and modified clicks still reach the expert
 * page) but a plain click is handed to the caller instead of navigating.
 */
function CarouselGuest({ title, data, onSelect }) {
  return (
    <Carousel title={title} spaceBetween={32} container={false}>
      {data.map((item, index) => {
        const inner = (
          <>
            <div className='rounded-full overflow-hidden relative mx-auto aspect-square w-40 lg:w-56 h-40 lg:h-56 block transition-transform duration-300 origin-center lg:hover:z-10 lg:hover:scale-[110%]'>
              <Image
                src={fitIn(item.image_url)}
                layout='fill'
                objectFit='cover'
                alt='Image'
              />
            </div>
            <p className='mt-3 text-base font-semibold lg:text-lg max-w-[160px] lg:max-w-[200px] mx-auto'>
              {item.name}
            </p>
            <p className='text-xs font-medium lg:text-sm opacity-40 mt-0.5 max-w-[160px] lg:max-w-[200px] mx-auto'>
              {item.title}
            </p>
          </>
        );

        return (
          <div key={item.slug || index} className='text-center'>
            {item.slug ? (
              <Link
                href={`/podcasts-masterclasses/experts/${item.slug}`}
                onClick={(event) => {
                  if (!onSelect) return;
                  if (
                    event.metaKey ||
                    event.ctrlKey ||
                    event.shiftKey ||
                    event.altKey ||
                    event.button !== 0
                  ) {
                    return;
                  }
                  event.preventDefault();
                  onSelect(item);
                }}
              >
                {inner}
              </Link>
            ) : (
              inner
            )}
          </div>
        );
      })}
    </Carousel>
  );
}
export default CarouselGuest;
